import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { BootstrapModule } from './bootstrap/bootstrap.module';
import { environment } from './environments/environment';
import 'replaywebpage';

// Initialize sentry
// new Sentry(environment);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(BootstrapModule)
    .catch(err => console.error(err));
